
import React, { useState, useEffect } from 'react';
import { Menu, X, ChevronDown, Presentation, HeartPulse, BriefcaseMedical, NotepadText, Microscope, Clock1, Hospital, TvMinimalPlay, Stethoscope, IndianRupee, MoveUp, MoveDown, TrendingUp, SmilePlus, GraduationCap, UserStar} from 'lucide-react';
import VideoSection from './components/VideoSection'
import ContactFormModal from './components/ContactFormModal';


export default function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const images = [
    { id: 21, url: './more/42.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 21, url: './more/22.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 22, url: './more/23.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 19, url: './more/29.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 23, url: './more/25.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 24, url: './more/26.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 25, url: './more/27.jpeg', title: 'Vishnoi Dental Hospital' },
    // { id: 20, url: './more/30.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 1, url: './1.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 2, url: './2.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 3, url: './3.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 4, url: './4.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 5, url: './5.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 6, url: './6.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 7, url: './7.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 8, url: './8.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 9, url: './9.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 10, url: './10.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 11, url: './11.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 12, url: './more/21.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 13, url: './more/10.jpg', title: 'Vishnoi Dental Hospital' },
    { id: 16, url: './more/19.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 17, url: './more/20.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 18, url: './more/11.jpg', title: 'Vishnoi Dental Hospital' },
    { id: 26, url: './more/1.jpg', title: 'Vishnoi Dental Hospital' },
    { id: 27, url: './more/2.jpg', title: 'Vishnoi Dental Hospital' },
    { id: 28, url: './more/15.png', title: 'Vishnoi Dental Hospital' },
    { id: 29, url: './more/12.jpg', title: 'Vishnoi Dental Hospital' },
    { id: 30, url: './more/32.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 27, url: './more/40.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 27, url: './more/41.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 31, url: './more/38.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 31, url: './more/39.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 31, url: './more/5.png', title: 'Vishnoi Dental Hospital' },
    { id: 14, url: './more/16.png', title: 'Vishnoi Dental Hospital' },
    { id: 15, url: './more/28.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 32, url: './more/31.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 33, url: './more/33.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 34, url: './more/34.png', title: 'Vishnoi Dental Hospital' },
    { id: 35, url: './more/2.png', title: 'Vishnoi Dental Hospital' },
    { id: 36, url: './more/6.png', title: 'Vishnoi Dental Hospital' },

    { id: 37, url: './more/24.jpeg', title: 'Vishnoi Dental Hospital' },



    { id: 38, url: './more/17.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 39, url: './more/18.jpeg', title: 'Vishnoi Dental Hospital' },
    { id: 40, url: './more/13.jpg', title: 'Vishnoi Dental Hospital' },
    { id: 41, url: './more/14.jpg', title: 'Vishnoi Dental Hospital' },
    { id: 42, url: './more/3.jpg', title: 'Vishnoi Dental Hospital' },
  ];

  const steps = [
    {
      number: 1,
      title: "Free Consultation",
      image: "/step-1.jpeg",
      description: "At Vishnoi Dental Hospital, our experienced implant specialists carefully examine your oral health and guide you about the best implant solution for you."
    },
    {
      number: 2,
      title: "Bone Density (CBCT) Test",
      image: "/step-2.jpeg",
      description: "We perform an advanced bone density test to assess jawbone strength, ensuring safe and long-lasting implant placement."
    },
    {
      number: 3,
      title: "Implant Planning",
      image: "/step-3.jpeg",
      description: "Using digital technology and precise planning, our experts design a customized implant plan for maximum accuracy and comfort."
    },
    {
      number: 4,
      title: " Implant Done",
      image: "/step-4.jpeg",
      description: "The implant procedure is completed using modern, painless techniques, giving you a strong, natural-looking tooth replacement."
    }
  ];

  const imagesAfter = [

    { id: 1, url: './more/7.png', title: 'Vishnoi Dental Hospital' },
    { id: 2, url: './more/8.png', title: 'Vishnoi Dental Hospital' },
    { id: 3, url: './more/9.png', title: 'Vishnoi Dental Hospital' },
  ]

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white font-sans">
      {/* Navigation */}
      <nav className={`fixed w-full top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center justify-center"><img src='/logo.png' style={{ margin: '16px 10px 0 0' }} width={'80px'} />

              <span className="text-2xl font-bold text-white bg-clip-text text-transparent line-hight-10" style={{ lineHeight: '25px' }}>
                Vishnoi Hospital <br />
              </span>
            </div>

            <div className="hidden md:flex items-center space-x-8">
              <button onClick={() => setIsModalOpen(true)} className="px-6 py-2 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full font-medium hover:scale-105 transition-transform">
                Free Consultation
              </button>
            </div>

            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden">
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-sm">
            <div className="px-4 py-4 space-y-4">
              <button onClick={() => setIsModalOpen(true)} className="w-full px-6 py-2 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full font-medium">
                Free Consultation
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 -mt-12 md:-mt-0">
        <div className="max-w-7xl mx-auto text-center">
          <div className="mb-8 animate-fade-in">
            <div className='flex justify-center items-center'>
              <img src='/NABH.webp' width='100px' />
            </div>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
              <span className="bg-gradient-to-r from-purple-800 to-blue-600 bg-clip-text text-transparent">Most Advanced {' '}</span> Dental Hospital in Kanpur
            </h1>
          </div>

          <div className="max-w-4xl mx-auto mb-8 rounded-2xl overflow-hidden shadow-2xl">
            {/* <video
              className="w-full"
              muted autoPlay loop
              playsInline
              preload="auto"
              poster="/logo.png"
            >
              <source src="/Dental_Implant.mp4" type="video/mp4" />
            </video> */}
            <iframe className='w-full' height="350" src="https://www.youtube.com/embed/5-BrjyUvGeM?si=uEgqAVAKrfqJi9rs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3">

              Full Mouth Dental Implants in a Single Visit
            </h2>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
              Offering single visit dental implants with guided surgery, CBCT & CEREC technology, and expert care by Dr. Manish Vishnoi. Book your free consultation today.

            </p>
          </div>

          <button onClick={() => setIsModalOpen(true)} className="px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full text-lg font-medium hover:scale-105 transition-transform inline-flex items-center gap-2">
            Free Consultation ➡️
          </button>
        </div>
      </section>

      {/* Consultation Section */}
      <section className="py-5 md:py-20 px-4 bg-gradient-to-b from-purple-900/20 to-transparent">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-r from-purple-900/40 to-blue-900/40 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">Book a Free Session</h2>
              <p className="text-gray-300 mb-6">
                Book a free dental implant session with our expert team. Get digital evaluation, guided implant planning, and personalized consultation at Vishnoi Dental.
              </p>
              <button onClick={() => setIsModalOpen(true)} className="px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full font-medium hover:scale-105 transition-transform inline-flex items-center gap-2">
                Free Consultation →
              </button>
            </div>
            <div className="flex-1 relative">
              <div className="w-64 h-64 bg-gradient-to-br from-purple-500 to-blue-500 rounded-full opacity-50 blur-3xl">

              </div>
              <img src='/Adobe Express - file (20).png' width='100%' className='absolute top-0 right-0' />
            </div>
          </div>
        </div>
      </section>


      {/* Dr. Manish Vishnoi */}
      <section className="py-5 md:py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-r from-purple-900/40 to-blue-900/40 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">Dr. Manish Vishnoi</h2>
              <p className="text-gray-300 mb-6">
                Dr. Manish Vishnoi (15+ years experience, 6000+ surgeries), our specialist team ensures accuracy, safety, and long-term success.
              </p>
              <button onClick={() => setIsModalOpen(true)} className="px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full font-medium hover:scale-105 transition-transform inline-flex items-center gap-2">
                Free Consultation →
              </button>
            </div>
            <div className="flex-1 relative">
              <div className="w-64 h-64 bg-gradient-to-br from-purple-500 to-blue-500 rounded-full opacity-50 blur-3xl">

              </div>
              <img src='/vishnoi/dr.png' className='absolute -bottom-8 md:-bottom-12 right-0 w-full md:w-2/4' />
            </div>
          </div>
        </div>
      </section>

              <section className="py-5 md:py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-r from-purple-900/40 to-blue-900/40 rounded-3xl p-8 md:p-12 grid grid-cols-2 md:grid-cols-4 items-center gap-8">
          <div className='p-3 bg-gradient-to-br from-purple-900/40 to-blue-900/40 rounded-3xl grid items-center justify-center text-center'>
          <TrendingUp className='text-white text-center block mx-auto text-6xl' />
          <p className='font-bold text-xl'>98%</p>
          <p>Success<br /> Rate</p>
          </div> 
          <div className='p-3 bg-gradient-to-br from-purple-900/40 to-blue-900/40 rounded-3xl grid items-center justify-center text-center'>
          <SmilePlus className='text-white text-center block mx-auto text-6xl'  />
          <p className='font-bold text-xl'>6000+</p>
          <p>Happy <br /> Patients</p>
          </div> 
          <div className='p-3 bg-gradient-to-br from-purple-900/40 to-blue-900/40 rounded-3xl grid items-center justify-center text-center'>
          <GraduationCap className='text-white text-center block mx-auto text-6xl'  />
          <p className='font-bold text-xl'>15+</p>
          <p>years<br /> experience</p>
          </div> 
          <div className='p-3 bg-gradient-to-br from-purple-900/40 to-blue-900/40 rounded-3xl grid items-center justify-center text-center'>
          <UserStar className='text-white text-center block mx-auto text-6xl'  />
          <p className='font-bold text-xl'>100%</p>
          <p>Patients<br /> Satisfaction</p>
          </div> 
          
          </div>
              </div>
</section>

      {/* Building */}
      <section className="py-5 md:py-20 px-4 ">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-r from-purple-900/40 to-blue-900/40 rounded-3xl p-2 md:p-12 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 relative">
              <div className="w-64 h-auto bg-gradient-to-br from-purple-500 to-blue-500 rounded-full opacity-50 blur-3xl">

              </div>
              <img src='/vishnoi/bulding.png' width='100%' className='md:absolute bottom-0 md:-bottom-16 left-0 rounded-3xl' />
            </div>
            <div className="flex-1">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">Premium Dental Care Under One Roof</h2>
              {/* <p className="text-gray-300 mb-6">
                Led by Dr. Manish Vishnoi (15+ years experience, 6000+ surgeries), our specialist team ensures accuracy, safety, and long-term success.
              </p> */}
              <button onClick={() => setIsModalOpen(true)} className="px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full font-medium hover:scale-105 transition-transform inline-flex items-center gap-2">
                Free Consultation →
              </button>
            </div>
            <div className="flex-1 relative">
              <div className="w-64 h-auto bg-gradient-to-br from-purple-500 to-blue-500 rounded-full opacity-50 blur-3xl">

              </div>
              <img src='/vishnoi/9.png' width='100%' className='md:absolute bottom-0 md:-top-16 right-0 rounded-3xl' />
            </div>
          </div>
        </div>
      </section>


      <div className="min-h-auto bg-black p-4 sm:p-6 lg:p-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl text-center pb-5 md:text-5xl font-bold mb-6"><span className="bg-gradient-to-r from-purple-800 to-blue-600 bg-clip-text text-transparent">Before After</span> Results</h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {imagesAfter.map((image) => (
              <div
                key={image.id}
                className="group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer bg-white"
                onClick={() => setSelectedImage(image)}
              >
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-64 object-cover transform group-hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>

        {selectedImage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative max-w-4xl max-h-full">
              <button
                className="absolute top-4 right-4 text-white text-4xl font-bold hover:text-gray-300"
                onClick={() => setSelectedImage(null)}
              >
                ×
              </button>
              <img
                src={selectedImage.url}
                alt={selectedImage.title}
                className="max-w-full max-h-screen object-contain"
              />
              <p className="text-white text-center mt-4 text-xl">{selectedImage.title}</p>
            </div>
          </div>
        )}
      </div>


      <img src='/mv.jpg' width='100%' />

      

      {/* Special */}
      <section className="py-5 md:py-20 px-4 ">
        <div className="max-w-7xl mx-auto">
           <h2 className="text-4xl text-center pb-5 md:text-5xl font-bold mb-10">Special <span className="bg-gradient-to-r from-purple-800 to-blue-600 bg-clip-text text-transparent">implants</span></h2>
          <div className="bg-gradient-to-r from-purple-900/40 to-blue-900/40 rounded-3xl p-2 md:p-12 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 relative">
              <div className="w-64 h-auto bg-gradient-to-br from-purple-500 to-blue-500 rounded-full opacity-50 blur-3xl">

              </div>
              <img src='/special-1.jpeg' width='100%' className='md:absolute bottom-0 md:-bottom-12 left-0 rounded-3xl' />
            </div>
            <div className="flex-1">
              <h2 className="text-xl md:text-2xl font-bold mb-4">Special implants possible when jawbone density is low</h2> 
              
              <button onClick={() => setIsModalOpen(true)} className="px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full font-medium hover:scale-105 transition-transform inline-flex items-center gap-2">
                Free Consultation →
              </button> 
            </div>
            <div className="flex-1 relative">
              <div className="w-64 h-auto bg-gradient-to-br from-purple-500 to-blue-500 rounded-full opacity-50 blur-3xl">

              </div>
              <img src='/special-2.jpeg' width='100%' className='md:absolute bottom-0 md:-top-14 right-0 rounded-3xl' />
            </div>
          </div>
        </div>
      </section>


      {/* CBCT */}
      <section className="py-5 md:py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-r from-purple-900/40 to-blue-900/40 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">Advanced Digital Implant Technology</h2>
              <p className="text-gray-300 mb-6">
                We use in-house CBCT, guided surgery, and CEREC systems to deliver precise, safe, and predictable implant results.
              </p>
              <button onClick={() => setIsModalOpen(true)} className="px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full font-medium hover:scale-105 transition-transform inline-flex items-center gap-2">
                Free Consultation →
              </button>
            </div>
            <div className="flex-1 relative">
              <div className="w-64 h-64 bg-gradient-to-br from-purple-500 to-blue-500 rounded-full opacity-50 blur-3xl">

              </div>
              <img src='/vishnoi/cbct.png' className='absolute -bottom-8 md:-bottom-24 right-0 w-full md:w-3/4' />
            </div>
          </div>
        </div>
      </section>

      {/* CEREC */}
      <section className="py-5 md:py-20 px-4 ">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-r from-purple-900/40 to-blue-900/40 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">Expert Care You Can Trust</h2>
              <p className="text-gray-300 mb-6">
                Complete same-day ceramic restoration system for crowns, inlays, and veneers using CEREC technology.
              </p>
              <button onClick={() => setIsModalOpen(true)} className="px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full font-medium hover:scale-105 transition-transform inline-flex items-center gap-2">
                Free Consultation →
              </button>
            </div>
            <div className="flex-1 relative">
              <div className="w-64 md:h-64 h-32 bg-gradient-to-br from-purple-500 to-blue-500 rounded-full opacity-50 blur-3xl">

              </div>
              <img src='/vishnoi/CEREC.png' className='absolute -bottom-8 md:-bottom-24 right-0 w-full md:w-3/4' />
            </div>
          </div>
        </div>
      </section>

      {/* CEREC */}
      <section className="py-5 md:py-20 px-4 ">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-r from-purple-900/40 to-blue-900/40 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">Implants possible in diabetic patients</h2>
              <p className="text-gray-300 mb-6">
                Dental implants are possible in diabetic patients, provided blood sugar levels are well controlled. With proper medical evaluation, good oral hygiene, and regular follow-ups, implant success rates can be comparable to non-diabetic patients.
              </p>
              <button onClick={() => setIsModalOpen(true)} className="px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full font-medium hover:scale-105 transition-transform inline-flex items-center gap-2">
                Free Consultation →
              </button>
            </div>
            <div className="flex-1 relative">
              <div className="w-64 md:h-64 h-32 hidden md:block bg-gradient-to-br from-purple-500 to-blue-500 rounded-full opacity-50 blur-3xl">

              </div>
              <img src='/diabetic.jpeg' className='md:absolute -bottom-8 md:-bottom-24 right-0 w-full md:w-2/4 rounded-lg' />
            </div>
          </div>
        </div>
      </section>

<section className="py-20 px-4 bg-gradient-to-b from-transparent to-purple-900/20">
        <div className="max-w-7xl mx-auto bg-gradient-to-r from-purple-900/40 to-blue-900/40 rounded-3xl p-2 md:p-12">
          <div className="text-center py-5">
            <div className='text-center rounded-full bg-green-300 p-4 px-10 w-fit text-2xl text-purple-900/80 mx-auto font-bold flex justify-center items-center'><IndianRupee /> Transparent Pricing</div>
            <h2 className='text-center text-white font-semibold text-4xl my-6'>Affordable Dental <br/> Implant Pricing</h2>
            <p className='text-center text-white text-xl'>Clear, honest pricing with no hidden
costs. Your investment in a confident
smile starts here.</p>

</div>
</div>
</section>

      {/* What You Get */}
      <section className="py-20 px-4 bg-gradient-to-b from-transparent to-purple-900/20">
        <div className="max-w-7xl mx-auto bg-gradient-to-r from-purple-900/40 to-blue-900/40 rounded-3xl p-2 md:p-12">
          <div className="text-center mb-16 py-5">
            <div className='text-center rounded-full bg-white/20 p-4 w-64 text-2xl mx-auto font-bold'>Starting Price</div>

            <h2 className="text-2xl md:text-5xl font-bold my-6 flex flex-wrap justify-center items-center gap-4">
              <span className="bg-gradient-to-r from-purple-800 to-blue-600 bg-clip-text flex items-center gap-1 justify-center text-7xl text-transparent"> <IndianRupee className='inline-block text-white text-7xl font-bold' />19000</span>
            </h2>
            <h2 className="text-2xl md:text-3xl font-bold mb-6">
              Implant Cost directly depends on <span className="bg-gradient-to-r from-purple-800 to-blue-600 bg-clip-text text-transparent">two Factors</span>
            </h2>
            <div className="text-gray-300 max-w-3xl mx-auto w-full flex justify-center gap-12 md:gap-24 text-lg md:text-xl">
              <span>Type of Implant</span>
              <span>Bone Density</span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-gradient-to-br from-purple-900/40 to-blue-900/40 rounded-3xl px-8 py-4 flex items-center">
              <div className="text-6xl w-1/3">
                <img src='/less bone.png' width='80px' />
              </div>
              <div>
                <h3 className="text-2xl font-bold">Less Bone</h3>
                <p className="text-gray-300 mb-6 flex items-center gap-2">
                  High Price <MoveUp />
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-900/40 to-blue-900/40 rounded-3xl px-8 py-4 flex items-center">
              <div className="text-6xl w-1/3">
                <img src='/good bone.png' width='80px' />
              </div>
              <div>
                <h3 className="text-2xl font-bold">Good Bone</h3>
                <p className="text-gray-300 mb-6 flex items-center gap-2">
                  Lower Price <MoveDown />
                </p>
              </div>
            </div>
          </div>

          <div className="text-center">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">Get Your Bone Density (CBCT) Test Now: <IndianRupee className='inline-block text-white text-5xl font-bold' />999</h3>
            <button onClick={() => setIsModalOpen(true)} className="px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full text-lg font-medium hover:scale-105 transition-transform">
              Book Now ➡️
            </button>
          </div>
        </div>
      </section>


       <div className="min-h-screen bg-black py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto bg-gradient-to-r from-purple-900/40 to-blue-900/40 rounded-3xl p-2 md:p-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step) => (
            <div key={step.number} className="bg-gradient-to-br from-purple-900/40 to-blue-900/40 rounded-lg shadow-lg overflow-hidden">
              {/* Step Header */}
              <div className="p-6 pb-4">
                <h3 className="text-white font-bold text-xl mb-4">STEP {step.number}</h3>
                
                {/* Image */}
                <div className="mb-4 rounded-lg overflow-hidden">
                  <img 
                    src={step.image} 
                    alt={step.title}
                    className="w-full h-48 object-cover"
                  />
                </div>
                
                {/* Title */}
                <h4 className="text-white font-bold text-xl mb-3 text-center">
                  {step.title}
                </h4>
                
                {/* Description */}
                <p className="text-gray-50 text-sm leading-relaxed text-center">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

      {/* Testimonials */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              What Our <span className="bg-gradient-to-r from-purple-800 to-blue-600 bg-clip-text text-transparent">Patients Say</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-b from-purple-900/30 to-transparent rounded-2xl p-8">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-yellow-400">⭐</span>
                ))}
              </div>
              <p className="text-gray-300 mb-6">
                “Main kaafi time se daant na hone ki wajah se pareshaan tha. Vishnoi Dental me aakar mujhe All-on-6 dental implants ek hi visit me mil gaye. Poora process digital planning ke saath hua aur treatment bilkul smooth raha. Aaj main confidence ke saath khana bhi kha pata hoon aur smile bhi karta hoon. Vishnoi Dental ek truly advanced dental hospital hai.”
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full"></div>
                <div>
                  <p className="font-bold">Rakesh Verma</p>
                  <p className="text-sm text-gray-400"> Kalyanpur, Kanpur</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-b from-purple-900/30 to-transparent rounded-2xl p-8">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-yellow-400">⭐</span>
                ))}
              </div>
              <p className="text-gray-300 mb-6">
                “Implant ke liye main nervous thi, lekin Vishnoi Dental ka in-house CBCT scan aur advanced setup dekh kar bharosa ho gaya. Doctors ne har cheez clearly samjhayi. Treatment painless aur safe raha. Yahan ki technology aur care dono hi best hain. Main Vishnoi Dental ko implant ke liye recommend karti hoon.”
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full"></div>
                <div>
                  <p className="font-bold">Sunita Singh</p>
                  <p className="text-sm text-gray-400">Govind Nagar, Kanpur</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-b from-purple-900/30 to-transparent rounded-2xl p-8">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-yellow-400">⭐</span>
                ))}
              </div>
              <p className="text-gray-300 mb-6">
                “Mera implant treatment Dr. Manish Vishnoi ne personally plan kiya. Unka 15 saal ka experience treatment ke har step me feel hota hai. Single visit me solution milna mere liye bahut badi baat thi. Agar aap advanced aur safe implant chahte ho to Vishnoi Dental best choice hai.”
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full"></div>
                <div>
                  <p className="font-bold">Anil Mishra</p>
                  <p className="text-sm text-gray-400">Rawatpur, Kanpur</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <VideoSection />

      <img src='/banner2.jpeg' width='100%' />

      {/* What You Get */}
      <section className="py-20 px-4 bg-gradient-to-b from-transparent to-purple-900/20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Everything Included in Your <span className="bg-gradient-to-r from-purple-800 to-blue-600 bg-clip-text text-transparent">Implant Care</span>
            </h2>
            <p className="text-gray-300 max-w-3xl mx-auto">
              From digital diagnostics and guided implant surgery to single-visit implant solutions and post-treatment support, every step of your care is planned, managed, and delivered in-house using advanced technology for safe, precise, and long-lasting results.
            </p>
          </div>

          {/* <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-gradient-to-br from-purple-900/40 to-blue-900/40 rounded-3xl p-8">
              <div className="text-6xl mb-6"><TvMinimalPlay /></div>
              <h3 className="text-2xl font-bold mb-4">Digital Implant Assessment</h3>
              <p className="text-gray-300 mb-6">
                A complete in-house CBCT scan and digital evaluation to plan your implant treatment with accuracy.
              </p>
              <button className="text-blue-400 hover:text-blue-300 font-medium inline-flex items-center gap-2">
                Learn More →
              </button>
            </div>

            <div className="bg-gradient-to-br from-blue-900/40 to-purple-900/40 rounded-3xl p-8">
              <div className="text-6xl mb-6"><HeartPulse /></div>
              <h3 className="text-2xl font-bold mb-4">Guided Implant Surgery</h3>
              <p className="text-gray-300 mb-6">
                Computer-guided implant placement for safer surgery, better precision, and faster recovery.
              </p>
              <button className="text-blue-400 hover:text-blue-300 font-medium inline-flex items-center gap-2">
                Learn More →
              </button>
            </div>
          </div> */}


          <div className="bg-gradient-to-r from-purple-900/40 to-blue-900/40 rounded-3xl mb-3 p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 relative">
              <div className="w-64 h-64 bg-gradient-to-br from-purple-500 to-blue-500 rounded-full opacity-50 blur-3xl">

              </div>
              <img src='/vishnoi/cbct.png' className='absolute -bottom-8 md:-bottom-24 right-0 w-full md:w-3/4' />
            </div>
            <div className="flex-1">
              <h3 className="text-3xl md:text-4xl font-bold mb-4">Digital Implant Assessment</h3>
              <p className="text-gray-300 mb-6">
                A complete in-house CBCT scan and digital evaluation to plan your implant treatment with accuracy.
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-purple-900/40 to-blue-900/40 rounded-3xl md:mt-20 mt-0 mb-3 p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 relative">
              <div className="w-64 md:h-64 h-40 bg-gradient-to-br from-purple-500 to-blue-500 rounded-full opacity-50 blur-3xl">

              </div>
              <img src='/vishnoi/CEREC.png' className='absolute -bottom-0 md:-bottom-24 right-0 w-full md:w-3/4' />
            </div>
            <div className="flex-1">
              <h3 className="text-3xl md:text-4xl font-bold mb-4">Guided Implant Surgery</h3>
              <p className="text-gray-300 mb-6">
                Computer-guided implant placement for safer surgery, better precision, and faster recovery.
              </p> 
            </div>
          </div>

          <div className="text-center">
            <button onClick={() => setIsModalOpen(true)} className="px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full text-lg font-medium hover:scale-105 transition-transform">
              Free Consultation ➡️
            </button>
          </div>
        </div>
      </section>

      {/* About Section */}
      {/* <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Who is <span className="bg-gradient-to-r from-purple-800 to-blue-600 bg-clip-text text-transparent">Dr. Manish Vishnoi?</span>
            </h2>
            <p className="text-gray-300 max-w-3xl mx-auto">
              Our brilliant team has one goal to make you more money and convert more visitors using our personalized Strategies and optimization
            </p>
          </div>

          <div className="grid md:grid-cols-1 gap-8 mb-8">

            <div className="bg-gradient-to-b from-purple-900/30 to-transparent rounded-2xl p-8 block md:flex items-center gap-6">
              <div className="w-full md:w-36 h-auto mb-3 md:mb md:h-36 bg-gradient-to-br from-blue-600 to-purple-600 md:rounded-full flex-shrink-0 overflow-hidden">
                <img src='https://vishnoidental.com/images/doctors/GMB-14.jpg' className=' md:rounded-full translate scale-330' />
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-2">Dr. Manish Vishnoi</h3>
                <p className="text-sm text-gray-400 mb-4">Director & Head Implantologist</p>
                <p className="text-gray-300">
                  Dr. Manish Vishnoi is a leading Cosmetic and Aesthetic Dental Surgeon in Kanpur, specializing in Single Visit Dental Treatments. With experience in over 6000 successful dental implant surgeries, he is known for his excellence in digital dentistry and precision-based care. As a CEREC Certified Digital Dentist, Dr. Vishnoi combines advanced technology with artistic expertise to deliver exceptional results in smile designing, dental makeovers, and implantology. His patient-centered approach ensures fast, safe, and highly aesthetic dental solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <div className="min-h-screen bg-black p-4 sm:p-6 lg:p-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl text-center pb-5 md:text-5xl font-bold mb-6">All <span className="bg-gradient-to-r from-purple-800 to-blue-600 bg-clip-text text-transparent">Dental Services</span> under One Roof</h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {images.map((image) => (
              <div
                key={image.id}
                className="group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer bg-white"
                onClick={() => setSelectedImage(image)}
              >
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-72 object-cover transform group-hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>

        {selectedImage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative max-w-4xl max-h-full">
              <button
                className="absolute top-4 right-4 text-white text-4xl font-bold hover:text-gray-300"
                onClick={() => setSelectedImage(null)}
              >
                ×
              </button>
              <img
                src={selectedImage.url}
                alt={selectedImage.title}
                className="max-w-full max-h-screen object-contain"
              />
              <p className="text-white text-center mt-4 text-xl">{selectedImage.title}</p>
            </div>
          </div>
        )}
      </div>

      {/* FAQ Section */}
      <section className="py-20 px-4 bg-gradient-to-b from-purple-900/20 to-transparent">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Frequently Asked <span className="bg-gradient-to-r from-purple-800 to-blue-600 bg-clip-text text-transparent">Questions</span>
            </h2>
          </div>

          <div className="space-y-4">
            {[
              {
                q: "What are dental implants?",
                a: "Dental implants are permanent replacements for missing teeth that function and look like natural teeth. They are placed securely in the jawbone to restore chewing, speech, and smile confidence."
              },
              {
                q: "What is All-on-6 dental implant treatment?",
                a: "All-on-6 is an advanced implant technique where a full set of fixed teeth is supported on six implants. In suitable cases, teeth can be placed in a single visit."
              },
              {
                q: "Is dental implant treatment painful?",
                a: "Implant procedures are performed using modern techniques and anesthesia, making the treatment comfortable. Most patients experience minimal discomfort during and after the procedure."
              },
              {
                q: "How long do dental implants last?",
                a: "With proper planning, digital placement, and good oral care, dental implants can last many years and are considered a long-term solution for missing teeth."
              },
              {
                q: "Can implants be done if I have less jaw bone?",
                a: "Yes. With advanced digital planning and guided surgery, implants can often be placed even in cases of reduced jaw bone. Each case is evaluated individually."
              },
              {
                q: "Why is CBCT scan important for implants?",
                a: "CBCT provides a 3D view of your jawbone, nerves, and bone density. It allows precise planning and safer implant placement, reducing risks and complications."
              },
              {
                q: "Why do dental implants fail at some clinics?",
                a: "Implants may fail due to lack of proper planning, outdated techniques, absence of in-house CBCT, or inexperienced staff. Implants require precision, expertise, and technology."
              },
              {
                q: "What makes Vishnoi Dental different for implant treatment?",
                a: "Vishnoi Dental offers guided implant surgery, complete digital planning, in-house CBCT & CEREC, and treatment led by Dr. Manish Vishnoi (15+ years experience, 6000+ surgeries) — all under one roof."
              },
              {
                q: "How many visits are required for implant treatment?",
                a: "This depends on your case. Many patients are eligible for single-visit implant solutions, while others may require staged treatment for best long-term results."
              },
              {
                q: "How much does dental implant treatment cost?",
                a: "Implant cost varies based on bone condition, type of implant, and treatment complexity. A detailed consultation and digital evaluation are required to determine the exact plan."
              }
            ].map((faq, index) => (
              <div key={index} className="bg-gradient-to-b from-purple-900/30 to-transparent rounded-2xl overflow-hidden">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-purple-900/20 transition-colors"
                >
                  <span className="font-medium">{faq.q}</span>
                  <ChevronDown className={`transform transition-transform ${openFaq === index ? 'rotate-180' : ''}`} />
                </button>
                {openFaq === index && (
                  <div className="px-6 pb-4 text-gray-300">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section> 

      {/* Footer */}
      <footer className="py-12 px-4 bg-black border-t border-purple-900/30">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col items-center gap-6">
            <div className="flex flex-wrap justify-center gap-6">
              <a href="/privacy-policy" className="text-gray-400 hover:text-blue-400 transition-colors">
                Privacy Policy
              </a>
              <span className="text-gray-600">|</span>
              <a href="/terms-and-conditions" className="text-gray-400 hover:text-blue-400 transition-colors">
                Terms & Conditions
              </a>
              <span className="text-gray-600">|</span>
              <a href="/refund-policy" className="text-gray-400 hover:text-blue-400 transition-colors">
                Refund Policy
              </a>
            </div>
            <p className="text-gray-500 text-sm">
              © 2025 vishnoidental. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }

        html {
          scroll-behavior: smooth;
        }
      `}</style>
      <a href='https://wa.me/+919336244678'><div className="fixed block md:hidden bottom-0 left-0 right-0 z-50 p-3">
        <button className="w-full bg-gradient-to-r from-green-600 to-green-600 rounded-full font-medium hover:scale-105 transition-transform text-white font-bold py-4 px-6 rounded-lg text-lg transition-all duration-300 active:scale-[0.98] shadow-lg flex justify-center items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" className='w-6' viewBox="0 0 24 24" fill="rgba(255,255,255,1)"><path d="M7.25361 18.4944L7.97834 18.917C9.18909 19.623 10.5651 20 12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 13.4363 4.37821 14.8128 5.08466 16.0238L5.50704 16.7478L4.85355 19.1494L7.25361 18.4944ZM2.00516 22L3.35712 17.0315C2.49494 15.5536 2.00098 13.8345 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C10.1671 22 8.44851 21.5064 6.97086 20.6447L2.00516 22ZM8.39232 7.30833C8.5262 7.29892 8.66053 7.29748 8.79459 7.30402C8.84875 7.30758 8.90265 7.31384 8.95659 7.32007C9.11585 7.33846 9.29098 7.43545 9.34986 7.56894C9.64818 8.24536 9.93764 8.92565 10.2182 9.60963C10.2801 9.76062 10.2428 9.95633 10.125 10.1457C10.0652 10.2428 9.97128 10.379 9.86248 10.5183C9.74939 10.663 9.50599 10.9291 9.50599 10.9291C9.50599 10.9291 9.40738 11.0473 9.44455 11.1944C9.45903 11.25 9.50521 11.331 9.54708 11.3991C9.57027 11.4368 9.5918 11.4705 9.60577 11.4938C9.86169 11.9211 10.2057 12.3543 10.6259 12.7616C10.7463 12.8783 10.8631 12.9974 10.9887 13.108C11.457 13.5209 11.9868 13.8583 12.559 14.1082L12.5641 14.1105C12.6486 14.1469 12.692 14.1668 12.8157 14.2193C12.8781 14.2457 12.9419 14.2685 13.0074 14.2858C13.0311 14.292 13.0554 14.2955 13.0798 14.2972C13.2415 14.3069 13.335 14.2032 13.3749 14.1555C14.0984 13.279 14.1646 13.2218 14.1696 13.2222V13.2238C14.2647 13.1236 14.4142 13.0888 14.5476 13.097C14.6085 13.1007 14.6691 13.1124 14.7245 13.1377C15.2563 13.3803 16.1258 13.7587 16.1258 13.7587L16.7073 14.0201C16.8047 14.0671 16.8936 14.1778 16.8979 14.2854C16.9005 14.3523 16.9077 14.4603 16.8838 14.6579C16.8525 14.9166 16.7738 15.2281 16.6956 15.3913C16.6406 15.5058 16.5694 15.6074 16.4866 15.6934C16.3743 15.81 16.2909 15.8808 16.1559 15.9814C16.0737 16.0426 16.0311 16.0714 16.0311 16.0714C15.8922 16.159 15.8139 16.2028 15.6484 16.2909C15.391 16.428 15.1066 16.5068 14.8153 16.5218C14.6296 16.5313 14.4444 16.5447 14.2589 16.5347C14.2507 16.5342 13.6907 16.4482 13.6907 16.4482C12.2688 16.0742 10.9538 15.3736 9.85034 14.402C9.62473 14.2034 9.4155 13.9885 9.20194 13.7759C8.31288 12.8908 7.63982 11.9364 7.23169 11.0336C7.03043 10.5884 6.90299 10.1116 6.90098 9.62098C6.89729 9.01405 7.09599 8.4232 7.46569 7.94186C7.53857 7.84697 7.60774 7.74855 7.72709 7.63586C7.85348 7.51651 7.93392 7.45244 8.02057 7.40811C8.13607 7.34902 8.26293 7.31742 8.39232 7.30833Z"></path></svg> Whatsapp
        </button>
      </div></a>
      <ContactFormModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}